export default __webpack_public_path__ + "static/media/Boehringer_Ingelheim_Logo.66846443.svg";